export default __webpack_public_path__ + "static/media/One.30e37500.jpg";